<template>
    <div id="plan-feature">
        <div class="feature">
            <div class="feature-title">{{ $t("message.instagramFeature") }}</div>
            <div class="feature-delete" @click="$emit('close')"><span class="material-icons">close</span></div>
        </div>
        <div class="feature-form">
            <div class="feature-item">
                <div class="feature-label">{{ $t("message.channelCount") }}</div>
                <div class="feature-input">
                    <a-input class="plan-input" :min="0" type="number" v-model="featureForm.instagramChannelCount" />
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.instagramMentionTicket">{{ $t("message.mentionTicket") }}</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.instagramPrivateReplyMessage">{{ $t("message.privateReplyMessage") }}</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.instagramCommentManagement">{{ $t("message.commentManagement") }}</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.instagramManageInbox">{{ $t("message.manageInbox") }}</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.instagramManageWithChatbot">{{ $t("message.manageWithChatbot") }}</a-checkbox>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { FeatureItems, Features } from "./index";

export default {
    name: "InstagramFeature",
    props: {
        value: {
            type: Object,
            default: {},
        },
        type: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        form: {},
        featureForm: {
            instagramChannelCount: 0,
            instagramMentionTicket: false,
            instagramPrivateReplyMessage: false,
            instagramCommentManagement: false,
            instagramManageInbox: false,
            instagramManageWithChatbot: false,
        },
    }),
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.form = this.$_.cloneDeep(this.value);
            const feature = this.form.features.find((x) => x.type === FeatureItems.INSTAGRAM);
            this.featureForm = feature || this.featureForm;
        },
    },
    watch: {
        value: {
            deep: true,
            handler() {
                this.init();
            },
        },
        form: {
            handler(newVal, oldVal) {
                if (!this.$_.isEqual(this.value, oldVal)) {
                    this.$emit("input", newVal);
                }
            },
            deep: true,
        },
        featureForm: {
            handler(v) {
                const response = { type: FeatureItems.INSTAGRAM, ...this.featureForm };
                response[Features.INSTAGRAM.CHANNEL_COUNT] = +v.instagramChannelCount || 0;
                const feature = this.form.features.findIndex((x) => x.type === FeatureItems.INSTAGRAM);
                if (feature < 0) {
                    this.form.features = [...this.form.features, response];
                } else {
                    this.form.features.splice(feature, 1, response);
                }
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss" scoped>
$bg-color: #ec4b1d;

#plan-feature {
    margin-top: 20px;

    .feature {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .feature-title {
            font-weight: bold;
            font-size: 16px;
        }

        .feature-delete {
            background-color: $bg-color;
            padding: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 2px;
            cursor: pointer;

            span {
                font-size: 14px;
                color: white;
            }
        }
    }
}
</style>
